"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var contexts_1 = require("../../contexts");
var TableContext_1 = __importDefault(require("./TableContext"));
var TableRowContext_1 = __importDefault(require("./TableRowContext"));
var TableRow = function (props) {
    var children = props.children, record = props.record, rowProps = __rest(props, ["children", "record"]);
    var formProps = react_1.useContext(contexts_1.FormContext).formProps;
    var isEditing = react_1.useContext(TableContext_1.default).isEditing;
    var rowContextvalue = react_1.useMemo(function () { return ({ isEditing: isEditing(record) }); }, [record, isEditing]);
    var valueChanged = rowContextvalue.isEditing && formProps && formProps.dirty;
    return (react_1.default.createElement("tr", __assign({}, rowProps, { className: "ant-app-editable-row " + (valueChanged ? 'dirty' : '') }),
        react_1.default.createElement(TableRowContext_1.default.Provider, { value: rowContextvalue }, children)));
};
exports.default = TableRow;
